// Ported from Octo.Mobile@79a7c69 src/api/endpoints.ts
// All Octo.Dal API endpoint constants
// Base URL is dynamic, configured via serverStore

export const ENDPOINTS = {
  // Auth - JWT
  AUTH_LOGIN: '/api/auth/login',
  AUTH_REFRESH: '/api/auth/refresh',
  AUTH_LOGOUT: '/api/auth/logout',

  // System - Session
  REGISTER_SESSION: '/api/system/register',
  REGISTER_FAILED_LOGIN: '/api/system/register-failed-login',
  CLOSE_SESSION: (sessionId: string) => `/api/system/close-session/${sessionId}`,

  // System - Users
  USER: (userId: string) => `/api/system/Kullanici/${userId}`,
  ALL_USERS: '/api/system/AllUsers',
  USER_PROFILE_IMAGE: (userId: string) => `/api/data/GetUserProfileImage/${userId}`,
  /** Kurulumu tanıtan bilgiler (müşteri adı) — başlıktaki "OCTO | firma" için. */
  SYSTEM_APP_INFO: '/api/system/AppInfo',
  SYSTEM_LICENSE_SUMMARY: '/api/system/LicenseSummary',
  /** Sunucu/veritabanı adı; yalnız sistem rolüne açık, parola İÇERMEZ. */
  SYSTEM_SERVER_INFO: '/api/system/ServerInfo',
  SYSTEM_CHANGE_PASSWORD: '/api/system/ChangePassword',

  // System - Metadata cache stamp
  METADATA_STAMP: '/api/system/MetadataStamp',
  METADATA_STAMP_OBJECT: (objectId: string) => `/api/system/MetadataStamp/${objectId}`,

  // System - Icons (tekilleştirilmiş menü ikonları)
  ICONS: '/api/system/Icons',
  ICON_CREATE: '/api/system/Icon',
  ICON_DELETE: (id: string) => `/api/system/Icon/${id}`,

  // System - Özet tipleri (Sum/Count/Avg/Min/Max → SummaryTypeId eşlemesi)
  SUMMARY_TYPES: '/api/system/SummaryTypes',

  // System - Node işlem tipleri (barkod okutma)
  NODE_ACTION_TYPES: (objectId: string) => `/api/system/NodeActionTypes/${objectId}`,

  // System - Screens
  SCREENS: '/api/system/Screen',
  /** Ekran ağacı için hafif liste (id, üst id, başlık, ikon) — `Screen` ucu 3,6 MB. */
  SCREENS_LITE: '/api/system/ScreensLite',
  /** Nesne seçicileri için hafif liste — `ObjectM` 3,4 MB. */
  OBJECTS_LITE: '/api/system/ObjectsLite',
  FORM_BUILDERS: '/api/system/FormBuilders',
  /** Bir ekranın yetkili kullanıcıları (yalnızca Visible olanlar). */
  SCREEN_USERS: (screenId: string) => `/api/system/ScreenUsers/${screenId}`,
  /** Ekran-kullanıcı yetkisi toplu verme/kaldırma. */
  SCREEN_USERS_BULK: '/api/system/ScreenUsers/BulkUpsert',
  SCREEN: (screenId: string) => `/api/system/Screen/${screenId}`,
  USER_SCREENS: (userId: string) => `/api/system/UserScreens/${userId}`,
  /** Menü ağacı: yetkili ekranlar + gezinmek için gereken üst modüller. */
  MENU_SCREENS: (userId: string) => `/api/system/MenuScreens/${userId}`,
  // Kullanıcının "girişte Node görünümü" tercihi (web NodeProfileMenu / Index kullanıcı menüsü)
  NODE_VIEW_PREFERENCE: (userId: string) => `/api/system/Users/NodeViewPreference/${userId}`,
  UPDATE_NODE_VIEW_PREFERENCE: '/api/system/Users/UpdateNodeViewPreference',
  TOGGLE_FAVORITE: '/api/system/toggle-visible',

  // System - Objects
  OBJECTS: '/api/system/ObjectM',
  OBJECT: (objectId: string) => `/api/system/ObjectM/${objectId}`,
  OBJECT_BY_NAME: (objectName: string) => `/api/system/ObjectM/${objectName}`,
  OBJECT_FIELDS: '/api/system/ObjectD',
  OBJECT_FIELDS_BY_ID: (objectId: string) => `/api/system/ObjectD/${objectId}`,
  OBJECT_DETAILS: '/api/system/ObjectDetails',
  OBJECT_DETAILS_BY_ID: (objectId: string) => `/api/system/ObjectDetails/${objectId}`,
  OBJECT_FILTERS: (objectId: string) => `/api/system/ObjectMFilters/${objectId}`,

  // System - Roles
  ROLE_OBJECTS: '/api/system/RolObjectsM',

  // Rol filtre kuralları (ScreenType = Policy)
  ROLES: '/api/system/GetRoller',
  OBJECTS_M: '/api/system/ObjectM',
  FILTER_POLICIES: '/api/system/FilterPolicies',
  FILTER_POLICY: (id: string) => `/api/system/FilterPolicies/${id}`,
  ROLE_FILTER_POLICIES: '/api/system/RoleFilterPolicies',
  ROLE_FILTER_POLICY: (id: string) => `/api/system/RoleFilterPolicies/${id}`,

  // Kullanıcı yönetimi (ScreenType = User) — liste için yukarıdaki ALL_USERS kullanılıyor
  USER_CREATE: '/api/system/Users/Create',
  USER_UPDATE: '/api/system/Users/Update',
  USER_DELETE: (userId: string) => `/api/system/Users/Delete/${userId}`,
  USER_UPDATE_ACTIVE: '/api/system/Users/UpdateActive',
  USER_UPDATE_CHAT: '/api/system/Users/UpdateChat',
  USER_UPDATE_AI_CHAT: '/api/system/Users/UpdateAiChat',
  USER_RESEND_PASSWORD: '/api/system/Users/ResendPassword',
  USER_UPDATE_LICENSE: '/api/system/Users/UpdateLicenseId',
  USER_CLEAR_LICENSE: (userId: string) => `/api/system/Users/ClearLicenseId/${userId}`,
  USER_UPDATE_NODE_LICENSE: '/api/system/Users/UpdateNodeLicenseId',
  USER_CLEAR_NODE_LICENSE: (userId: string) => `/api/system/Users/ClearNodeLicenseId/${userId}`,
  USER_CHECK_CODE: '/api/system/Users/CheckUserCode',

  // Rol yetkileri (Octo Lab)
  ROLE_OBJECT_PERMISSIONS: (objectId: string) => `/api/system/RoleObjectPermissions/${objectId}`,
  SAVE_ROLE_OBJECT_PERMISSION: '/api/system/RoleObjectPermissions',
  DELETE_ROLE_OBJECT_PERMISSION: (roleObjectId: string) =>
    `/api/system/RoleObjectPermissions/${roleObjectId}`,
  FIELD_ROLE_PERMISSIONS: (objectFieldId: string) => `/api/system/FieldRolePermissions/${objectFieldId}`,
  SAVE_FIELD_ROLE_PERMISSION: '/api/system/FieldRolePermissions',
  ACTION_ROLE_PERMISSIONS: (objectActionId: string) => `/api/system/ActionRolePermissions/${objectActionId}`,
  SAVE_ACTION_ROLE_PERMISSION: '/api/system/ActionRolePermissions',
  ROLE_OBJECT_FIELDS: (objectId: string, roleId: string) =>
    `/api/system/RoleObjectFieldsByObjectAndRole/${objectId}/${roleId}`,

  // System - Object Actions (Veri İşlemleri)
  OBJECT_ACTIONS: (objectId: string) => `/api/system/ObjectsVeriIslemleri/${objectId}`,
  ROLE_OBJECT_ACTIONS: (objectId: string, roleId: string) =>
    `/api/system/RoleObjectActionsByObjectAndRole/${objectId}/${roleId}`,

  // System - Templates
  HTML_CARD_TEMPLATES: '/api/system/HtmlCardTemplates',
  HTML_CARD_TEMPLATE: (id: string) => `/api/system/HtmlCardTemplates/${id}`,
  HTML_SUMMARY_TEMPLATES: '/api/system/HtmlSummaryTemplates',
  HTML_SUMMARY_TEMPLATE: (id: string) => `/api/system/HtmlSummaryTemplates/${id}`,
  RAZOR_TEMPLATE: (id: string) => `/api/system/RazorTemplates/${id}`,
  /** Şablonu SUNUCUDA derleyip HTML döndürür (Blazor ile aynı derleyici). */
  RAZOR_RENDER: (id: string) => `/api/system/RazorTemplates/${id}/Render`,

  // Data - Select
  SELECT_MASTER_FILTER: (
    objectId: string,
    userId: string,
    filterId?: string,
    filter?: string,
    maxRecords?: number,
  ) => {
    // Always send objectFilterId (empty GUID when none) — matches web behavior
    const filterIdSegment = filterId || '00000000-0000-0000-0000-000000000000';
    let url = `/api/data/SelectMasterFilter/${objectId}/${userId}/${filterIdSegment}`;
    if (filter) url += `/${encodeURIComponent(filter)}`;
    // SP @MaxRecords çıktısı / Sys_Objects.MaxRecords → TOP N
    if (maxRecords && maxRecords > 0) url += `?maxRecords=${maxRecords}`;
    return url;
  },
  /** Sayfalı grid verisi (OFFSET/FETCH). Gövde: SelectMasterPageRequest. */
  SELECT_MASTER_PAGE: '/api/data/SelectMasterPage',
  // SP-data-source ekran: veri SP'nin SELECT sonucundan gelir, gövde SqlParameterModel[]
  SELECT_MASTER_FILTER_SP: (objectId: string, userId: string) =>
    `/api/data/SelectMasterFilterSp/${objectId}/${userId}`,
  // Nesne "yönlendirici" SP mi (OUTPUT @ResultDataSourceObjectId var mı) — sys.parameters'tan
  SP_HAS_REDIRECT_OUTPUT: (objectId: string) => `/api/data/SpHasRedirectOutput/${objectId}`,
  SELECT_LOOKUP: (fieldId: string, userId: string, ignoreWhere?: boolean) =>
    `/api/data/SelectLookup/${fieldId}/${userId}${ignoreWhere ? '/true' : ''}`,

  // Data - CRUD
  UPSERT: '/api/data/Upsert',
  DELETE: '/api/data/delete',

  // Data - Files
  UPLOAD_FILE: '/api/data/UploadFile',

  // Data - SP
  EXECUTE_SP: '/api/data/execute-stored-procedure',
  EXECUTE_SCALAR: '/api/data/execute-scalar',
  EXECUTE_SCALAR_WITH_PARAMS: '/api/data/execute-scalar-with-params',

  // Data - Profil fotoğrafı
  UPDATE_USER_PROFILE_IMAGE: '/api/data/UpdateUserProfileImage',

  // System - Report Actions
  REPORT_ACTIONS: (objectId: string) => `/api/system/RaporIslems/${objectId}`,
  // System - Rapor tanımları (aktif, ad sıralı: {reportId, reportName})
  REPORT_LIST: '/api/system/RaporTanims/List',
  // Raporun parametre adları — görev ekinin parametre satırları bu adlarla eşleşmek zorunda
  REPORT_PARAMETERS: (reportId: string) => `/api/system/RaporTanims/${reportId}/Parameters`,
  // Data - Reports
  CREATE_REPORT: (reportActionId: string, filterValue: string) =>
    `/api/data/CreateReport/${reportActionId}/${filterValue}`,
  WRITE_REPORT_LOG: '/api/data/WriteReportLog',

  // Data - Survey
  GET_SURVEY: (surveyId: string) => `/api/data/GetSurvey/${surveyId}`,
  SUBMIT_SURVEY: '/api/data/submit-response',
  UPSERT_SURVEY: '/api/data/UpsertSurveyAsync',

  // Data - Password (eski uç; merkezî kimlik desteklemez — SYSTEM_CHANGE_PASSWORD kullan)
  CHANGE_PASSWORD: '/api/data/ChangePassword',

  // Messages
  MESSAGES_SUMMARY: (userId: string) => `/api/messages/summary/${userId}`,
  MESSAGES_CHAT: (u1: string, u2: string) => `/api/messages/chat/${u1}/${u2}`,
  MESSAGES_GROUP: (groupId: string) => `/api/messages/group/${groupId}`,
  MESSAGES_SEND_PRIVATE: '/api/messages/send-private',
  MESSAGES_SEND_GROUP: '/api/messages/send-group',
  MESSAGES_MARK_READ: (userId: string, senderId: string) =>
    `/api/messages/mark-read/${userId}/from/${senderId}`,
  MESSAGES_MARK_READ_GROUP: (userId: string, groupId: string) =>
    `/api/messages/mark-read-group/${userId}/group/${groupId}`,
  MESSAGES_UNREAD_COUNT: (userId: string) => `/api/messages/unread-count/${userId}`,
  MESSAGES_SEARCH: '/api/messages/search',
  MESSAGES_CREATE_GROUP: '/api/messages/create-group',
  MESSAGES_UPLOAD_ATTACHMENT: '/api/messages/upload-attachment',
  MESSAGES_ATTACHMENTS: (messageId: string) => `/api/messages/attachments/${messageId}`,
  MESSAGES_CLEAR_CHAT: (userId: string, partnerId: string) =>
    `/api/messages/clear-chat/${userId}/with/${partnerId}`,
  MESSAGES_GROUP_MEMBERS_DETAIL: (groupId: string) => `/api/messages/group-members-detail/${groupId}`,
  MESSAGES_ADD_GROUP_MEMBER: '/api/messages/add-group-member',
  MESSAGES_REMOVE_GROUP_MEMBER: '/api/messages/remove-group-member',

  // Users with session status
  // Zamanlanmış görevler (ScreenType = Worker) — uçların tamamı SystemController'da hazır.
  // WORKER_TASKS ayrıca SP'nin @EXCPrinterName çıktısıyla Print görevi açarken kullanılıyor.
  WORKER_SEARCH: '/api/system/WorkerTasks/Search',
  WORKER_TASK: (id: number) => `/api/system/WorkerTasks/${id}`,
  WORKER_TASKS: '/api/system/WorkerTasks',
  WORKER_ATTACHMENTS: (id: number) => `/api/system/WorkerTasks/${id}/Attachments`,
  WORKER_ATTACHMENT_PARAMS: (attachmentId: number) =>
    `/api/system/WorkerTaskAttachments/${attachmentId}/Parameters`,
  WORKER_PAUSE: (id: number) => `/api/system/WorkerTasks/${id}/Pause`,
  WORKER_RESUME: (id: number) => `/api/system/WorkerTasks/${id}/Resume`,
  WORKER_RUN_NOW: (id: number) => `/api/system/WorkerTasks/${id}/RunNow`,
  WORKER_TYPES: '/api/system/WorkerTaskTypes',
  // Saklı yordam adları ve bir yordamın parametreleri (SP görevinin eki için)
  STORED_PROCEDURES: '/api/system/StoredProcedures',
  STORED_PROCEDURE_PARAMETERS: (name: string) =>
    `/api/system/StoredProcedures/${encodeURIComponent(name)}/Parameters`,
  WORKER_WHATSAPP_MESSAGES: (id: number) => `/api/system/WorkerTasks/${id}/WhatsAppMessages`,
  WHATSAPP_BALANCE: '/api/system/WhatsAppCredits/Balance',
  WHATSAPP_TEMPLATES: '/api/system/WhatsAppTemplates',
  USERS_WITH_STATUS: (userId: string) => `/api/system/users/all-with-session/${userId}`,

  // AI Chat
  AI_STATUS: '/api/claudecode/status',
  AI_CHAT_STREAM_START: '/api/claudecode/chat/stream/start',
  AI_CHAT_STREAM_CONTINUE: '/api/claudecode/chat/stream/continue',
  AI_CONVERSATIONS: (userId: string) => `/api/aichat/conversations/${userId}`,
  AI_CONVERSATION_MESSAGES: (conversationId: string) =>
    `/api/aichat/conversations/${conversationId}/messages`,
  AI_CONVERSATION_RENAME: (conversationId: string) => `/api/aichat/conversations/${conversationId}/rename`,
  AI_CONVERSATION_DELETE: (conversationId: string) => `/api/aichat/conversations/${conversationId}`,
  AI_QUOTA: (userId: string) => `/api/aichat/quota/${userId}`,
  AI_UPLOAD_ATTACHMENT: '/api/aichat/upload-attachment',
  // --- Web (Octo.Web.React) eklemeleri ---
  HEALTH: '/health',
  CONNECTIONS: (refresh?: boolean) => `/api/connections${refresh ? '?refresh=true' : ''}`,
  CONNECTIONS_LOOKUP: '/api/connections/lookup',
  CONNECTIONS_LOGIN_CANDIDATES: '/api/connections/login-candidates',
  AUTH_IMPERSONATE: '/api/auth/impersonate',
  CLOSE_OLD_SESSIONS: (userId: string, sessionId: string) => `/api/system/close-old/${userId}/${sessionId}`,
  UPDATE_LAST_ACTIVE: '/api/system/update-last-active',
  USER_SETTING: (userId: string, key: string) =>
    `/api/system/UserSettings/${userId}/${encodeURIComponent(key)}`,
  USER_SETTINGS_SAVE: '/api/system/UserSettings',
  DASHBOARD_USERS: (userId: string) => `/api/system/DashBoardUsers/${userId}`,
  EXCHANGE_RATES_LATEST: '/api/system/ExchangeRates/Latest',
  /** Son N kur kaydı (yeniden eskiye) — değişim okunu hesaplamak için ikisi istenir. */
  EXCHANGE_RATES_RECENT: (count: number) => `/api/system/ExchangeRates/Recent/${count}`,
  /*
   * Rol kimliği AÇIKÇA gönderiliyor (masaüstü de `GetRolObjectsM(ObjectId, _roleId)`
   * ile öyle yapıyor). Sunucu normalde rolü token'dan okuyor; token süresi dolduğunda
   * ve kimlik zorlaması kapalı olduğunda istek kimliksiz geçiyor, rol yetkileri BOŞ
   * dönüyor ve ekran yetkisizmiş gibi açılıyordu. Sunucu yine de kendi talebinden
   * gelen rolü yalnızca kimliksiz/sistem çağrılarında kabul ediyor (ResolveRole).
   */
  SCREEN_BUNDLE: (screenId: string, roleId?: string | null) =>
    `/api/system/ScreenBundle/${screenId}${roleId ? `?roleId=${roleId}` : ''}`,
  OBJECT_BUNDLE: (objectId: string, roleId?: string | null) =>
    `/api/system/ObjectBundle/${objectId}${roleId ? `?roleId=${roleId}` : ''}`,

  // ── OctoLab (nesne tasarımcısı) ──
  /** Açılışta bir kez okunan listeler (nesneler, tipler, roller, stiller). */
  LAB_META: '/api/octolab/meta',
  /** Bir nesnenin tasarım verisinin tamamı — masaüstündeki 11 seri çağrının yerine. */
  LAB_OBJECT_BUNDLE: (objectId: string) => `/api/octolab/objects/${objectId}/bundle`,
  LAB_SAVE_OBJECT: '/api/octolab/objects',
  LAB_BULK_FIELDS: '/api/octolab/bulk-update-fields',
  LAB_ADD_FIELD: '/api/octolab/add-objectd',
  LAB_DELETE_FIELD: (id: string) => `/api/octolab/deleteobjectd/${id}`,
  LAB_BULK_ACTIONS: '/api/octolab/bulk-update-actions',
  LAB_ADD_ACTION: '/api/octolab/add-veriislemi',
  LAB_DELETE_ACTION: (id: string) => `/api/octolab/delete-veriislemi/${id}`,
  LAB_BULK_DETAILS: '/api/octolab/bulk-update-details',
  LAB_ADD_DETAIL: '/api/octolab/add-detail',
  LAB_DELETE_DETAIL: (id: string) => `/api/octolab/delete-detail/${id}`,
  LAB_BULK_FILTERS: '/api/octolab/bulk-update-filters',
  LAB_ADD_FILTER: '/api/octolab/add-filter',
  LAB_DELETE_FILTER: (id: string) => `/api/octolab/delete-filter/${id}`,
  LAB_BULK_REPORT_ACTIONS: '/api/octolab/bulk-update-report-actions',
  LAB_BULK_FORMATTING: '/api/octolab/bulk-update-formatting-rules',
  LAB_ADD_FORMATTING: '/api/octolab/add-formatting-rule',
  LAB_DELETE_FORMATTING: (id: string) => `/api/octolab/delete-formatting-rule/${id}`,
  LAB_BULK_CALCULATIONS: '/api/octolab/bulk-update-calculation-rules',
  LAB_ADD_CALCULATION: '/api/octolab/add-calculation-rule',
  LAB_DELETE_CALCULATION: (id: string) => `/api/octolab/delete-calculation-rule/${id}`,
  LAB_ADD_REPORT_ACTION: '/api/octolab/add-report-action',
  LAB_DELETE_REPORT_ACTION: (id: string) => `/api/octolab/delete-report-action/${id}`,
  LAB_BULK_USER_VIEWS: '/api/octolab/user-views/bulk',
  LAB_ADD_USER_VIEW: '/api/octolab/user-views/add',
  LAB_DELETE_USER_VIEW: (id: string) => `/api/octolab/user-views/${id}`,
  LAB_SQL_DEFINITION: (objectName: string) =>
    `/api/octolab/get-sql-definition/${encodeURIComponent(objectName)}`,
  LAB_EXECUTE_SQL: '/api/octolab/execute-safe-query',
  LAB_HISTORY: (objectId: string) => `/api/octolab/objects/${objectId}/history`,
  LAB_HISTORY_PARAMS: (logId: string) => `/api/octolab/history/${logId}/params`,
  /**
   * Sayfalı yükleme bayrağı — nesnenin diğer alanlarından AYRI yazılır.
   * Çekirdek metadata koruması nesne satırının tamamının güncellenmesini reddediyor;
   * bu tercih kuruluma özgü olduğu için tek kolonluk ayrı bir uçtan geçiyor.
   */
  LAB_SET_PAGED_LOADING: (objectId: string) => `/api/octolab/objects/${objectId}/paged-loading`,
  LAB_REFRESH_OBJECTS: '/api/octolab/objects/refresh',
  LAB_REFRESH_FIELDS: (objectId: string) => `/api/octolab/objects/${objectId}/refresh-fields`,
  SELECT_LOOKUP_BATCH: '/api/data/SelectLookupBatch',
} as const;

export const STORAGE_KEYS = {
  SERVER_URL: '@octo_server_url',
  SESSION: '@octo_session',
  ACCESS_TOKEN: '@octo_access_token',
  REFRESH_TOKEN: '@octo_refresh_token',
  THEME_MODE: '@octo_theme_mode',
  REMEMBER_ME: '@octo_remember_me',
  SAVED_USER: '@octo_saved_user',
  PUSH_TOKEN: '@octo_push_token',
  BIOMETRIC_ENABLED: '@octo_biometric_enabled',
  LANGUAGE: '@octo_language',
  NOTIFICATIONS_CACHE: '@octo_notifications_cache',
  FAVORITES: '@octo_favorites',
  CHAT_CLEAR_TIMESTAMPS: '@octo_chat_clear_timestamps',
} as const;
